exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#age-ranges .row {\n\tpadding-bottom: 4px;\n}\n#age-ranges .col {\n\tpadding-bottom: 0 !important;\n}\n#age-ranges p:not(:first-child) {\n\tmargin-bottom: 0 !important;\n}\n#age-ranges .v-text-field {\n     padding-top: 0;\n     margin-top: 0;\n}\n#age-ranges .v-text-field__details {\n\tdisplay: none !important;\n}\n#age-ranges .v-select__selection--comma {\n\ttext-overflow: unset;\n}\n", ""]);

// exports
